module.exports = __webpack_public_path__ + "img/2.235bb644.png";